<!-- An accent-topped header strip so this reads as a control surface rather than one more data
     card — the same treatment the Admin Dashboard's filter panel uses. -->
<div class="filter-card">
  <div class="filter-head">
    <span class="filter-title"><i class="pi pi-sliders-h"></i> Filters</span>
    <span class="filter-hint">Narrow every figure below</span>
  </div>

<div class="filter-bar">
  <div class="filter">
    <label>Year</label>
    <p-select [ngModel]="selYear()" (ngModelChange)="selYear.set($event)" [options]="yearOptions"
      optionLabel="label" optionValue="value" [showClear]="true" placeholder="All years" appendTo="body" />
  </div>
  <div class="filter">
    <label>Month</label>
    <p-select [ngModel]="selMonth()" (ngModelChange)="selMonth.set($event)" [options]="monthOptions"
      optionLabel="label" optionValue="value" [showClear]="true" [disabled]="!selYear()"
      placeholder="All months" appendTo="body" />
  </div>
  <div class="filter">
    <label>Financial Year</label>
    <p-select [ngModel]="selFinYear()" (ngModelChange)="selFinYear.set($event)" [options]="finYearOptions"
      optionLabel="label" optionValue="value" [showClear]="true" placeholder="Select FY" appendTo="body" />
  </div>
  <div class="filter">
    <label>From</label>
    <p-datepicker [ngModel]="fromDate()" (ngModelChange)="fromDate.set($event)" dateFormat="dd M yy"
      [showIcon]="true" iconDisplay="input" [readonlyInput]="true" placeholder="From date" appendTo="body" />
  </div>
  <div class="filter">
    <label>To</label>
    <p-datepicker [ngModel]="toDate()" (ngModelChange)="toDate.set($event)" dateFormat="dd M yy"
      [showIcon]="true" iconDisplay="input" [readonlyInput]="true" [minDate]="fromDate() || undefined"
      placeholder="To date" appendTo="body" />
  </div>
  @if (isAdmin) {
    <div class="filter">
      <label>Partner</label>
      <p-select [ngModel]="selPartnerId()" (ngModelChange)="selPartnerId.set($event)" [options]="partnerOptions"
        optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true"
        placeholder="All partners" appendTo="body" />
    </div>
  }

  @if (fromDate()) {
    <small class="hint-muted">An explicit From/To range overrides the Year &amp; Financial Year filters.</small>
  }

  <div class="filter-actions">
    <p-button label="Apply" icon="pi pi-filter" (onClick)="apply()" />
    <p-button label="Reset" icon="pi pi-filter-slash" [outlined]="true" severity="secondary" (onClick)="reset()" />
  </div>
</div>
</div>
